import { RouterProvider } from '@tanstack/react-router';
import { HelmetProvider } from 'react-helmet-async';

import './App.css';

import { useTrackingInstallion } from '@/tracking/Tracking.hooks';

import { router } from './App.router';

function App() {
	useTrackingInstallion();

	const classNames = ['App'];
	/*if (config.app.contentProtection) {
		// classNames.push('content-protection');
	}*/

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
